<fieldset>
  <legend>{{ legend | translate }}</legend>
  <nb-checkbox [ngModel]="end.home" (ngModelChange)="setHome($event)" [disabled]="disabled || !home?.street">
    {{ 'tracking.trips.home' | translate }}@if (home?.street) { ({{ home.street }} {{ home.number }}, {{ home.town }})}
  </nb-checkbox>
  @if (!end.home) {
    @if (!manual) {
      <bst-places-editor mode="structured" fullWidth size="small" [placeholder]="'places.search' | translate"
                         [disabled]="disabled" [ngModel]="search" (ngModelChange)="pick($event)"></bst-places-editor>
      @if (!revealed) {
        <a href="javascript:void(0)" class="reveal" (click)="reveal()">{{ 'places.type_manually' | translate }}</a>
      }
    } @else {
      <span class="places-message" role="status">{{ 'places.unavailable' | translate }}</span>
    }
    @if (manual || revealed) {
      <div class="address">
        <!-- Visible labels: a placeholder alone is gone once the field is filled. -->
        <label class="addr street">{{ 'tracking.trips.street' | translate }}
          <input nbInput fieldSize="small" fullWidth maxlength="120" [(ngModel)]="end.street" (ngModelChange)="emit()"></label>
        <label class="addr number">{{ 'tracking.trips.number' | translate }}
          <input nbInput fieldSize="small" fullWidth maxlength="20" [(ngModel)]="end.number" (ngModelChange)="emit()"></label>
        <label class="addr postcode">{{ 'tracking.trips.postcode' | translate }}
          <input nbInput fieldSize="small" fullWidth maxlength="12" [(ngModel)]="end.postcode" (ngModelChange)="emit()"></label>
        <label class="addr town">{{ 'tracking.trips.town' | translate }}
          <input nbInput fieldSize="small" fullWidth maxlength="80" [(ngModel)]="end.town" (ngModelChange)="emit()"></label>
        @if (partial) { <span class="places-message" role="status">{{ 'places.partial' | translate }}</span> }
      </div>
    }
  }
</fieldset>
